"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _axios = _interopRequireDefault(require("axios"));
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment"));
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'extendedWarrantyResults',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        orderNumber: '',
        barCode: '',
        qrcode: '',
        status: '',
        ruleCodeList: [],
        retailerId: '',
        retailerName: '',
        createStartTime: '',
        createEndTime: '',
        tireOrderRatingList: [],
        sku: '',
        sapDescription: ''
      },
      form: {},
      region: [],
      regionOptions: [],
      lookupList: {
        WARRANTY_EXTENSION_REVIEW_MAPPING: {},
        TIRE_L_RULE_MAPPING: {},
        TIRE_POSITION_MAPPING: {}
      },
      statusList: [{
        code: '正常',
        name: '正常'
      }, {
        code: '异常',
        name: '异常'
      }]
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var createEndTime = _this.searchVal.createEndTime;
          if (createEndTime) {
            var maxDate = (0, _moment.default)(createEndTime, 'YYYY-MM-DD').toDate();
            // const minDate = moment(createEndTime, 'YYYY-MM-DD').subtract(30, 'days')
            if (timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var createStartTime = _this.searchVal.createStartTime;
          if (createStartTime) {
            var minDate = (0, _moment.default)(createStartTime, 'YYYY-MM-DD').toDate();
            // const maxDate = moment(createStartTime, 'YYYY-MM-DD').add(30, 'days') // 向后30天
            if (timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.getLookupTypeCode();
    setTimeout(function () {
      _this2.searchData();
    }, 300);
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      if (this.searchVal.createStartTime && !this.searchVal.createStartTime.includes('00:00:00')) {
        this.searchVal.createStartTime = this.searchVal.createStartTime + ' 00:00:00';
      }
      if (this.searchVal.createEndTime && !this.searchVal.createEndTime.includes('23:59:59')) {
        this.searchVal.createEndTime = this.searchVal.createEndTime + ' 23:59:59';
      }
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      console.log(param);
      this.listLoading = true;
      this.$api.reportModule.getCciTireStoreOrderList(param, this.sourceApi.token).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.data.items;
        _this3.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this3.listLoading = false;
      });
    },
    resetData: function resetData() {
      var _this4 = this;
      setTimeout(function () {
        _this4.searchVal.orderNumber = '';
        _this4.searchVal.barCode = '';
        _this4.searchVal.qrcode = '';
        _this4.searchVal.status = '';
        _this4.searchVal.ruleCodeList = [];
        _this4.searchVal.retailerId = '';
        _this4.searchVal.retailerName = '';
        _this4.searchVal.createStartTime = '';
        _this4.searchVal.createEndTime = '';
        _this4.searchVal.tireOrderRatingList = [];
        _this4.searchVal.sku = '';
        _this4.searchVal.sapDescription = '';
        _this4.searchData();
      }, 300);
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    downloadExcel: function downloadExcel() {
      var _this5 = this;
      if (!this.searchVal.createStartTime || !this.searchVal.createEndTime) {
        (0, _elementUi.Message)({
          message: this.$t('common.pleaseSelect') + this.$t('sfe.extendedwarrantyresults.input.createTime'),
          type: 'warning',
          duration: 1.5 * 1000
        });
        return;
      }
      var startTime = (0, _moment.default)(this.searchVal.createStartTime);
      var endTime = (0, _moment.default)(this.searchVal.createEndTime);
      var diffdays = endTime.diff(startTime, 'days');
      console.log('====diffdays====', diffdays);
      if (diffdays > 30) {
        (0, _elementUi.Message)({
          message: '一次只能导出30天数据',
          type: 'warning',
          duration: 1.5 * 1000
        });
        return;
      }
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.extendedwarrantyresults.exportFileName');
      if (this.searchVal.createStartTime && !this.searchVal.createStartTime.includes('00:00:00')) {
        this.searchVal.createStartTime = this.searchVal.createStartTime + ' 00:00:00';
      }
      if (this.searchVal.createEndTime && !this.searchVal.createEndTime.includes('23:59:59')) {
        this.searchVal.createEndTime = this.searchVal.createEndTime + ' 23:59:59';
      }
      this.$api.reportModule.exportCciTireStoreOrderList(this.searchVal).then(function (res) {
        _this5.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this5.$message.error(_this5.$t('sfe.extendedwarrantyresults.input.exportFailed'));
        console.log(err);
        _this5.isLoading = false;
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this6 = this;
      var param = {
        configItemCodeList: ['WARRANTY_EXTENSION_REVIEW', 'TIRE_L_RULE', 'TIRE_POSITION']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        if (res.data) {
          _this6.lookupList = res.data || {};

          // 查找值数据转换
          for (var key in _this6.lookupList) {
            _this6.generateMapping(key, _this6.lookupList[key] || []);
          }
        }
      }).catch(function () {});
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this7 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this7.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    }
  }
};